import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { KngFilterPanelComponent } from './kng-filter-panel.component';
import { KngFilterPanelService } from './kng-filter-panel.service';

@NgModule({
	declarations: [
		KngFilterPanelComponent
	],
	imports: [
		CommonModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatSidenavModule,
		MatRadioModule,
		MatCheckboxModule,
		ReactiveFormsModule,
		MatDatepickerModule,
		MatNativeDateModule,
		FormsModule
	],
	exports: [
		KngFilterPanelComponent
	],
	providers: [
		KngFilterPanelService
	]
})
export class KngFilterPanelModule {}
